module.exports = __webpack_public_path__ + "static/media/big-pro-vouchar.9a89d983.png";